import { WorklistParams, WorklistViewParams } from '@/Models/GenericWorklist/WorklistParams';
import { isEqual } from 'lodash';

export const isWorklistParamsEquivalent = (paramA: WorklistParams, paramB: WorklistParams, ignoreOffset = false): boolean => {
    const { Pagination: paginationA, ...paramAWithoutPagination } = paramA;
    const { Pagination: paginationB, ...paramBWithoutPagination } = paramB;

    const paramsWithoutPaginationEquivalent = isEqual(paramAWithoutPagination, paramBWithoutPagination);

    const { Offset: offsetA, ...paginationAWithoutOffset } = paginationA;
    const { Offset: offsetB, ...paginationBWithoutOffset } = paginationB;
    const paginationWithoutOffsetIsEquivalent = isEqual(paginationAWithoutOffset, paginationBWithoutOffset);
    const offsetMatches = ignoreOffset || offsetA === offsetB;

    return paramsWithoutPaginationEquivalent && paginationWithoutOffsetIsEquivalent && offsetMatches;
};

export const isWorklistViewParamsEquivalent = (viewA: WorklistViewParams, viewB: WorklistViewParams): boolean => {
    const withNonActiveIgnoredA = filterVisibleViewParams(viewA);
    const withNonActiveIgnoredB = filterVisibleViewParams(viewB);

    const viewConfigsAreEquivalent = isEqual(withNonActiveIgnoredA, withNonActiveIgnoredB);
    return viewConfigsAreEquivalent;
};

const filterVisibleViewParams = (viewParams: WorklistViewParams): WorklistViewParams => {
    return {
        Columns: [...viewParams.Columns.filter((x) => x.Visible)],
        Filters: [...viewParams.Filters.filter((x) => x.Visible)],
    } satisfies WorklistViewParams;
};
